import React from "react";

export default function TruthInput({ value, onChange, disabled }) {
  return (
    <>
      <style>
        {`
          .truth-choice {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 42px;
            height: 42px;
            border-radius: 9999px;
            border: 2px solid var(--color-border, #f97316);
            background: transparent;
            color: var(--color-text, #ffffff);
            font-weight: 700;
            font-size: 16px;
            transition:
              transform 0.12s ease-out,
              box-shadow 0.12s ease-out,
              border-color 0.12s ease-out,
              background-color 0.12s ease-out,
              color 0.12s ease-out;
            cursor: pointer;
          }

          .truth-choice:hover {
            background: rgba(249, 115, 22, 0.25);
            border-color: #f97316;
            box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.55);
            transform: translateY(-1px);
          }

          .truth-choice.selected {
            background: rgba(249, 115, 22, 0.4);
            border-color: #f97316;
            box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.8);
          }

          .truth-choice.disabled {
            opacity: 0.6;
            cursor: default;
            box-shadow: none;
            transform: none;
          }
        `}
      </style>

      <div
        style={{
          display: "flex",
          gap: 10,
          marginTop: 8,
          flexWrap: "wrap",
        }}
      >
        {["P", "F"].map((label) => {
          const isSelected = value === label;

          const classes = [
            "truth-choice",
            isSelected ? "selected" : "",
            disabled ? "disabled" : "",
          ]
            .filter(Boolean)
            .join(" ");

          return (
            <button
              key={label}
              type="button"
              className={classes}
              disabled={disabled}
              onClick={() => !disabled && onChange(label)}
            >
              {label}
            </button>
          );
        })}
      </div>
    </>
  );
}
